module.exports = __webpack_public_path__ + "static/img/img6.5cf4d09.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/img6.png
// module id = 5M/A
// module chunks = 1